import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './App.css';
import Navbar from './Components/Navbar';
import { HelmetProvider } from "react-helmet-async";
import MainRoutes from './Pages/MainRoutes';
import Footer from './Components/Footer';
import GdprModal from './Components/GdprModal';

function App() {
  const helmetContext = {};

  const [showFooter, setShowFooter] = useState(false);
 const location = useLocation();
 const hideNavAndFooter = location.pathname === '/sublanding';
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowFooter(true);
    }, 2000); // 2 seconds
    return () => clearTimeout(timer); // cleanup on unmount
  }, []);

  return (
    <div>
      <HelmetProvider context={helmetContext}>
        {/* <Navbar /> */}
        {!hideNavAndFooter && <Navbar />}
        <GdprModal />
        <MainRoutes />
        {/* {showFooter && <Footer />} */}
          {!hideNavAndFooter && showFooter && <Footer />}
      </HelmetProvider>
    </div>
  );
}

export default App;
